"use strict";
export const needsSmallFont = () => {
  return true;
};
